import { Link } from "react-router-dom";
import heroImg from "../Assets/hero-mechanic.jpg";

const Home = () => {
  return (
    <main className="bg-gray-50">

      <section className="relative bg-black">
        <div className="mx-auto">
          <div className="relative flex min-h-[70vh] items-center">
            <div className="absolute inset-0 overflow-hidden">
              <img
                src={heroImg}
                alt="Trusted Wrench mechanic working under a vehicle"
                className="h-full w-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-black/70 md:bg-black/60" />
            </div>
            <div className="relative z-10 max-w-3xl md:ml-[40vh] ml-2">
              <h1 className="text-5xl font-extrabold tracking-tight text-white sm:text-6xl md:text-7xl">
                Trusted Wrench
              </h1>
              <p className="mt-3 text-xl font-semibold text-blue-400">
                Built on Integrity
              </p>
              <p className="mt-6 text-lg leading-8 text-white/90">
                Local mechanic with 10+ years of experience. Honest service,
                quality repairs, and dependable results every time.
              </p>
              <div className="mt-8 flex flex-wrap gap-4">
                <Link
                  to="/appointments"
                  className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-7 py-3 text-base font-semibold text-white hover:bg-blue-500 transition"
                >
                  Book Appointment
                </Link>
                <Link
                  to="/services"
                  className="inline-flex items-center justify-center rounded-xl border border-white/30 bg-white/10 px-7 py-3 text-base font-semibold text-white hover:bg-white/20 transition"
                >
                  View Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
